///
/// 타입 정의
///
// 메세지 타입
type Message = string;
// 메세지 맵 타입
type MessageMap = Record<string, Message>;

type StringMap = Record<string, string>;
/**
 * License 관련 문자열 정의
 */

/*
 * 대화상자 메세지 정의
 **/
const LicenseExpirationMessage =
  "Your license has expired.\nPurchase a license at https://iaidimage.com";

const DialogMessage: MessageMap = {
  ConfirmChangeDataOnDCMView: "Data will be changed \nDo you want to continue?",
  ConfirmUnloadDataOnDCMView:
    "Data will be unloaded \nDo you want to continue?",
  ConfirmUnloadAllDataOnDCMView:
    "All data will be unloaded \nDo you want to continue?",
  ConfirmRemoveDataOnDCMView: "Data will be removed \nDo you want to continue?",
  ConfirmRemoveAllDataOnDCMView:
    "All data will be removed \nDo you want to continue?",
};
const SyncState: StringMap = {
  SYNC_DISABLE: "sync-disabled",
  SYNC_AUTO: "sync-auto",
  SYNC_MANUAL: "sync-manual",
};
///
/// SeriesList 썸네일로 사용되는 슬라이스 위치
///
const ThumbnailSlice: StringMap = {
  first: "first",
  last: "last",
  mid: "mid",
};

const Strings = {
  DialogMessage,
  ThumbnailSlice,
  LicenseExpirationMessage,
};

export default Strings;
